import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import CatchLinks from './CatchLinks';
import createDynamicRoutesModule, { loadRewrites, getRouteInfo } from './dynamicRoutesModule';
import RoutesProvider from './RoutesProvider';
export default function dynamicRoutesExtension() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      getIsEnabled = _ref.getIsEnabled,
      refreshInterval = _ref.refreshInterval,
      rewritesFilterList = _ref.rewritesFilterList,
      _ref$routeTypePageMap = _ref.routeTypePageMap,
      routeTypePageMap = _ref$routeTypePageMap === void 0 ? {} : _ref$routeTypePageMap,
      _ref$builderRoutePage = _ref.builderRoutePageMap,
      builderRoutePageMap = _ref$builderRoutePage === void 0 ? {} : _ref$builderRoutePage,
      getUseBuilderRouting = _ref.getUseBuilderRouting,
      getIgnoreBuilderProductListingRoutes = _ref.getIgnoreBuilderProductListingRoutes,
      getShouldUseRoutingByTld = _ref.getShouldUseRoutingByTld,
      handleRouteInfo = _ref.handleRouteInfo;

  return {
    id: 'dynamic-route',
    redux: {
      modules: [createDynamicRoutesModule({
        routeTypePageMap: routeTypePageMap,
        builderRoutePageMap: builderRoutePageMap
      })]
    },
    server: process.browser ? {} : {
      init: function init() {
        require('./config');
      },
      configure: function configure(server) {
        var _require = require('./dynamicRoutesMiddleware'),
            dynamicRoutesMiddleware = _require["default"];

        server.useTracked('dynamicRoutesMiddleware', dynamicRoutesMiddleware({
          getIsEnabled: getIsEnabled,
          refreshInterval: refreshInterval,
          rewritesFilterList: rewritesFilterList,
          routeTypePageMap: routeTypePageMap,
          builderRoutePageMap: builderRoutePageMap,
          getUseBuilderRouting: getUseBuilderRouting,
          getIgnoreBuilderProductListingRoutes: getIgnoreBuilderProductListingRoutes,
          getShouldUseRoutingByTld: getShouldUseRoutingByTld
        }));
      },
      handler: function handler(_ref2) {
        var handler = _ref2.handler,
            app = _ref2.app,
            server = _ref2.server;

        var _require2 = require('./dynamicRouteHandler'),
            dynamicRouteHandler = _require2["default"];

        return dynamicRouteHandler({
          handler: handler,
          app: app,
          server: server
        });
      }
    },
    app: {
      render: function render(props, children) {
        return /*#__PURE__*/React.createElement(RoutesProvider, null, /*#__PURE__*/React.createElement(CatchLinks, null, children));
      }
    },
    page: function page(options) {
      return {
        getInitialProps: {
          enhance: function enhance(getInitialProps) {
            return /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
                var state, routeInfo, handlerResponse;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!process.browser) {
                          _context.next = 8;
                          break;
                        }

                        if (!options.routeInfoRequired) {
                          _context.next = 6;
                          break;
                        }

                        _context.next = 4;
                        return ctx.store.dispatch(loadRewrites([ctx.asPath]));

                      case 4:
                        state = ctx.store.getState(); // TODO: 404 if it doesn't exist?

                        ctx.routeInfo = getRouteInfo(state, ctx.asPath);

                      case 6:
                        _context.next = 9;
                        break;

                      case 8:
                        if (ctx.req) {
                          ctx.routeInfo = ctx.req.context.routeInfo;
                        }

                      case 9:
                        if (!(handleRouteInfo && ctx.routeInfo)) {
                          _context.next = 15;
                          break;
                        }

                        routeInfo = ctx.routeInfo;
                        _context.next = 13;
                        return handleRouteInfo({
                          ctx: ctx,
                          routeInfo: routeInfo
                        });

                      case 13:
                        handlerResponse = _context.sent;
                        ctx.routeInfo = _objectSpread(_objectSpread({}, ctx.routeInfo), {}, {
                          handlerResponse: handlerResponse
                        });

                      case 15:
                        return _context.abrupt("return", getInitialProps(ctx));

                      case 16:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x) {
                return _ref3.apply(this, arguments);
              };
            }();
          }
        }
      };
    }
  };
}